import axios from 'axios';
import apiClient from '../server';

const WORKER_URL = 'http://localhost:3002';

/**
 * Fetch RA city event listings
 * @param {Object} params - Parameters
 * @param {string} params.city - City name (e.g., "montreal", "toronto")
 * @param {number} [params.page=1] - Page number (1-20)
 * @param {string} [params.country="ca"] - Country code (e.g., "ca", "us", "uk")
 */
export const fetchRACityListings = async ({ city, page = 1, country = 'ca' }) => {
  try {
    const response = await axios.post(`${WORKER_URL}/batch/ra-city-listings`, {
      city,
      page,
      country
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching RA city listings:", error.response?.data || error);
    throw error;
  }
};

/**
 * Compare RA events with database
 * @param {Array} events - Array of events from RA
 */
export const compareRAEvents = async (events) => {
  try {
    const response = await apiClient.post('/events/compare-ra', { events });
    return response.data;
  } catch (error) {
    console.error("Error comparing RA events:", error.response?.data || error);
    throw error;
  }
};

/**
 * Scrape single RA event details
 * @param {string} url - RA event URL
 */
export const scrapeRAEvent = async (url) => {
  try {
    const response = await axios.post(`${WORKER_URL}/scrape`, { url });
    return response.data;
  } catch (error) {
    console.error("Error scraping RA event:", error.response?.data || error);
    throw error;
  }
};

// RA Cities reference data
export const RA_CITIES = {
  ca: [
    { value: 'montreal', label: 'Montreal' },
    { value: 'toronto', label: 'Toronto' },
    { value: 'vancouver', label: 'Vancouver' },
    { value: 'calgary', label: 'Calgary' },
    { value: 'ottawa', label: 'Ottawa' },
  ],
  us: [
    { value: 'newyork', label: 'New York' },
    { value: 'losangeles', label: 'Los Angeles' },
    { value: 'chicago', label: 'Chicago' },
    { value: 'miami', label: 'Miami' },
    { value: 'sanfrancisco', label: 'San Francisco' },
    { value: 'detroit', label: 'Detroit' },
    { value: 'seattle', label: 'Seattle' },
  ],
  uk: [
    { value: 'london', label: 'London' },
    { value: 'manchester', label: 'Manchester' },
    { value: 'bristol', label: 'Bristol' },
    { value: 'glasgow', label: 'Glasgow' },
    { value: 'leeds', label: 'Leeds' },
  ],
  de: [
    { value: 'berlin', label: 'Berlin' },
    { value: 'munich', label: 'Munich' },
    { value: 'frankfurt', label: 'Frankfurt' },
  ],
  es: [
    { value: 'barcelona', label: 'Barcelona' },
    { value: 'madrid', label: 'Madrid' },
    { value: 'ibiza', label: 'Ibiza' },
  ],
  nl: [
    { value: 'amsterdam', label: 'Amsterdam' },
  ],
  fr: [
    { value: 'paris', label: 'Paris' },
  ],
};

export const RA_COUNTRIES = [
  { value: 'ca', label: 'Canada' },
  { value: 'us', label: 'USA' },
  { value: 'uk', label: 'UK' },
  { value: 'de', label: 'Germany' },
  { value: 'es', label: 'Spain' },
  { value: 'nl', label: 'Netherlands' },
  { value: 'fr', label: 'France' },
];
